export default __webpack_public_path__ + "static/media/Apparel Resource.e31ad930.png";